export default __webpack_public_path__ + "static/media/sword4.7d2cf813.svg";